var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWheely(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 132,
    viewBox: "0 0 132 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M114.374 65.9969C114.374 79.3557 108.961 91.4497 100.206 100.205C91.4505 108.96 79.3568 114.373 65.998 114.373C52.6392 114.373 40.5452 108.96 31.7902 100.205C23.0352 91.4494 17.6222 79.3557 17.6222 65.9969C17.6222 52.6381 23.035 40.5441 31.7902 31.7891C40.5455 23.0341 52.6392 17.6211 65.998 17.6211C79.3568 17.6211 91.4508 23.0339 100.206 31.7891C108.961 40.5444 114.374 52.6381 114.374 65.9969Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2111 65.9978L14.9992 59.1836L0.000427246 65.9978C0.000427246 84.2223 7.38906 100.721 19.3299 112.667L35.7923 108.196L39.2781 92.7185C32.4392 85.8796 28.2111 76.4327 28.2111 65.9978Z",
    fill: "#9B5AF8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9993 0C47.7748 0 31.2765 7.38863 19.3304 19.3294L23.1684 36.3488L39.2786 39.2777C46.1175 32.4388 55.5644 28.2106 65.9993 28.2106L74.7799 14.9988L65.9993 0Z",
    fill: "#6D5EF6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M112.67 19.334L98.1741 21.3155L92.7219 39.2822C99.5607 46.1211 103.789 55.568 103.789 66.0029L117.894 73.2984L132 66.0029C132 47.7784 124.611 31.2801 112.67 19.334Z",
    fill: "#34D399"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M107.828 95.2043L92.7217 92.7227C85.8828 99.5615 76.4359 103.79 66.001 103.79L57.516 115.997L66.001 132C84.2255 132 100.724 124.612 112.67 112.671L107.828 95.2043Z",
    fill: "#F59E0B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9992 103.79V132C47.7746 132 31.2764 124.612 19.3303 112.671L39.2785 92.7227C46.1174 99.5615 55.5643 103.79 65.9992 103.79Z",
    fill: "#F472B6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M132 65.998C132 84.2226 124.611 100.721 112.67 112.667L92.7219 92.7188C99.5607 85.8799 103.789 76.433 103.789 65.998H132Z",
    fill: "#22D3EE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M112.671 19.3294L92.7228 39.2777C85.884 32.4388 76.4371 28.2106 66.0021 28.2106V0C84.2267 0 100.725 7.38863 112.671 19.3294Z",
    fill: "#A78BFA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2781 39.2822C32.4392 46.1211 28.2111 55.568 28.2111 66.0029H0.000427246C0.000427246 47.7784 7.38906 31.2801 19.3299 19.334L39.2781 39.2822Z",
    fill: "#34D399"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheely);
export default __webpack_public_path__ + "static/media/wheely.7d0c4e646302ff1709f44744cf5ba974.svg";
export { ForwardRef as ReactComponent };